@if (!!form) {
  <div>
    <fieldset
      class="radio"
      [attr.data-cy]="
        'equipmentSelectionList' + (optionItem.equipmentName | removeSpecialChars) + 'Fieldset'
      "
    >
      @for (option of optionItem.equipmentOptions; track option) {
        <div [formGroup]="form" class="row" (click)="toggleOption(option.optionName)">
          <div class="flex pad-10">
            <input
              type="radio"
              [formControlName]="optionItem.equipmentKey"
              [value]="option.optionName"
              (change)="toggleOption(option.optionName)"
              [attr.data-cy]="
                'equipmentSelectionItemRadio' +
                (optionItem.equipmentName + option.optionName | removeSpecialChars)
              "
            />
            <label class="checkbox-label" [attr.aria-label]="option.optionName"></label>
            <p class="pad-left-10">
              <span>{{ option.optionName }}</span
              ><br /><span class="caption">{{ option.caption }}</span>
            </p>
          </div>
        </div>
      }
      <div [formGroup]="form" class="row" (click)="toggleOption('other')">
        <div class="flex pad-10">
          <input
            type="radio"
            [formControlName]="optionItem.equipmentKey"
            value="other"
            (change)="toggleOption('other')"
            [attr.data-cy]="
              'equipmentSelectionItem' + (optionItem.equipmentName | removeSpecialChars) + 'Other'
            "
          />
          <label class="checkbox-label" [attr.aria-label]="'not sure'"></label>
          <p class="pad-left-10">
            <span>I'm not sure </span> <br /><span class="caption"
              >Your agent will follow up with you to discuss this</span
            >
          </p>
        </div>
      </div>
    </fieldset>
  </div>
}
